import React, { useState, useEffect } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { appText } from "../../../../texts";
import L from "leaflet";

const { searchText } = appText;

const CoordinateInput = ({ onAddMarker, mapRef, geoJsonLayer }) => {
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [currentMarker, setCurrentMarker] = useState(null);
  const [circleLayers, setCircleLayers] = useState([]);
  const [isCoordinatesEntered, setIsCoordinatesEntered] = useState(false);
  const [isSearchClicked, setIsSearchClicked] = useState(false); // وضعیت برای نمایش دکمه‌ها
  const [isCirclesVisible, setIsCirclesVisible] = useState(false); // وضعیت برای جلوگیری از نمایش دوباره شعاع‌ها

  const handleLongitudeChange = (e) => {
    const value = e.target.value;
    if (/^[0-9.-]*$/.test(value)) {
      setLongitude(value);
    }
    setIsCoordinatesEntered(latitude && e.target.value);
  };

  const handleRemoveCircles = () => {
    circleLayers.forEach((circle) => {
      if (mapRef && mapRef.hasLayer(circle)) {
        mapRef.removeLayer(circle);
      }
    });
    setCircleLayers([]);  // خالی کردن state دایره‌ها
    setIsCirclesVisible(false); // تنظیم وضعیت به false
  };

  const handleShowCircles = () => {
    if (currentMarker && mapRef) {
      circleLayers.forEach((circle) => {
        if (mapRef.hasLayer(circle)) {
          mapRef.removeLayer(circle);
        }
      });
      const radius1 = 5000;
      const radius2 = 10000;

      const circle1 = L.circle([currentMarker.lat, currentMarker.lng], {
        radius: radius1,
        color: "blue",
        weight: 2,
        fillOpacity: 0.3,
        interactive: false,
      }).addTo(mapRef);

      const circle2 = L.circle([currentMarker.lat, currentMarker.lng], {
        radius: radius2,
        color: "green",
        weight: 2,
        fillOpacity: 0.3,
        interactive: false,
      }).addTo(mapRef);

      setCircleLayers([circle1, circle2]);
      setIsCirclesVisible(true);  // تنظیم وضعیت به true پس از نمایش دایره‌ها
    }
  };

  const handleLatitudeChange = (e) => {
    const value = e.target.value;
    if (/^[0-9.-]*$/.test(value)) {
      setLatitude(value);
    }
    setIsCoordinatesEntered(e.target.value && longitude);
  };

  useEffect(() => {
    if (currentMarker && mapRef) {
      mapRef.setView([currentMarker.lat, currentMarker.lng], 10);
    }
  }, [currentMarker, mapRef]);

  const handleAddMarker = () => {
    if (latitude && longitude) {
      const newMarker = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
      onAddMarker(newMarker);

      if (mapRef) {
        // حذف دایره‌های قبلی
        circleLayers.forEach((circle) => {
          if (mapRef.hasLayer(circle)) {
            mapRef.removeLayer(circle);
          }
        });
        setCircleLayers([]);

        // رفتن به مکان جدید
        mapRef.setView([newMarker.lat, newMarker.lng], 10, { animate: true });

        // رسم دایره‌های جدید
        const radius1 = 5000;
        const radius2 = 10000;

        const center = [newMarker.lat, newMarker.lng];
        const angle1 = 0; // درجه صفر
        const angle2 = (30 * Math.PI) / 180; // ۴ درجه به رادیان
        const dest1 = [
          center[0] + (radius1 / 111000) * Math.cos(angle1),
          center[1] + (radius1 / (111000 * Math.cos(center[0] * Math.PI / 180))) * Math.sin(angle1)
        ];

        const dest2 = [
          center[0] + (radius2 / 111000) * Math.cos(angle2),
          center[1] + (radius2 / (111000 * Math.cos(center[0] * Math.PI / 180))) * Math.sin(angle2)
        ];

        const circle1 = L.circle(center, {
          radius: radius1,
          color: "blue",
          weight: 2,
          fillOpacity: 0.3,
          interactive: false,
        }).addTo(mapRef);

        const circle2 = L.circle(center, {
          radius: radius2,
          color: "green",
          weight: 2,
          fillOpacity: 0.3,
          interactive: false,
        }).addTo(mapRef);
        const line1 = L.polyline([center, dest1], {
          color: "blue",
          weight: 3,
          dashArray: '4 4'
        }).addTo(mapRef);
        line1.bindTooltip("5 km", { permanent: true,direction: "center", offset: [0, -10] });

        // خط + برچسب برای شعاع ۱۰ کیلومتر
        const line2 = L.polyline([center, dest2], {
          color: "green",
          weight: 3,
          dashArray: '4 4'
        }).addTo(mapRef);
        line2.bindTooltip("10 km", { permanent: true, direction: "center", offset: [0, -10] });

        // ذخیره در state برای حذف بعدی
        setCircleLayers([circle1, circle2, line1, line2]);
        setIsCirclesVisible(true); // چون دوباره رسم شدن
        setCurrentMarker(newMarker);
        setIsSearchClicked(true);
      }
    }
  };


  const isButtonDisabled = !longitude || !latitude;

  return (
    <div className="flex w-full flex-col mt-3">
      <p className="text-[12px]">{searchText.titleText}</p>
      <div className="flex">
        <div className="w-1/2">
          <div>
            <label> {searchText.lonText}</label>
            <span className="font-sans">(Lon)</span>
          </div>
          <input
            type="text"
            value={longitude}
            onChange={handleLongitudeChange}
            className="mt-2 text-[12px] mb-3 w-[98%] rounded-md border border-gray-500 justify-start border-solid p-2"
          />
        </div>
        <div className="w-1/2">
          <div>
            <label> {searchText.latText}</label>
            <span className="font-sans">(Lat)</span>
          </div>
          <input
            type="text"
            value={latitude}
            onChange={handleLatitudeChange}
            className="text-[12px] mt-2 mb-3 w-[98%] rounded-md border justify-end border-gray-500 border-solid p-2"
          />
        </div>
      </div>
      <button
        className="w-full flex items-center justify-center px-1 font-[myFont] rounded-md border border-solid bg-[#888] text-[12px] text-white"
        onClick={handleAddMarker}
        style={{
          padding: "8px 20px",
          cursor: isButtonDisabled ? "not-allowed" : "pointer",
          backgroundColor: isButtonDisabled ? "gray" : "#02bfe7",
          border: isButtonDisabled ? "gray" : "#02bfe7",
          color: "white",
        }}
        disabled={isButtonDisabled}
      >
        {searchText.searchText}
        <MdKeyboardArrowLeft size={"20px"} />
      </button>
      {isSearchClicked && (
        <div className="flex mt-2 w-full justify-center gap-x-2">
          <button
            onClick={handleRemoveCircles}
            className="bg-red-500 w-1/2 text-white font-semibold py-2 px-4 rounded-md transition-all duration-300 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
          >
            حذف شعاع
          </button>

          <button
            onClick={handleShowCircles}
            className="bg-green-500 w-1/2 text-white font-semibold py-2 px-4 rounded-md transition-all duration-300 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            نمایش شعاع
          </button>

        </div>
      )}
    </div>
  );
};

export default CoordinateInput;
